var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuStudents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6E9CBC8E-210A-4DD5-B5B1-A7311F924D3B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-530.000000, -1474.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "team-line",
    transform: "translate(530.000000, 1474.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,11 C14.7614237,11 17,13.2385763 17,16 L17,22 L15,22 L15,16 C15.0000885,14.4114424 13.7618215,13.0981954 12.176,13.005 L12,13 C10.4114424,12.9999115 9.09819538,14.2381785 9.005,15.824 L9,16 L9,22 L7,22 L7,16 C7,13.2385763 9.23857625,11 12,11 L12,11 Z M5.5,14 C5.779,14 6.05,14.033 6.31,14.094 C6.13902367,14.603004 6.03777016,15.1328189 6.009,15.669 L6,16 L6,16.086 C5.88505329,16.0448688 5.76549278,16.0180012 5.644,16.006 L5.5,16 C4.72737809,16.0000371 4.0811717,16.5869466 4.007,17.356 L4,17.5 L4,22 L2,22 L2,17.5 C2,15.5670034 3.56700338,14 5.5,14 L5.5,14 Z M18.5,14 C20.4329966,14 22,15.5670034 22,17.5 L22,22 L20,22 L20,17.5 C19.9999629,16.7273781 19.4130534,16.0811717 18.644,16.007 L18.5,16 C18.325,16 18.157,16.03 18,16.085 L18,16 C18,15.334 17.892,14.694 17.691,14.096 C17.95,14.033 18.221,14 18.5,14 Z M5.5,8 C6.88071187,8 8,9.11928813 8,10.5 C8,11.8807119 6.88071187,13 5.5,13 C4.11928813,13 3,11.8807119 3,10.5 C3,9.11928813 4.11928813,8 5.5,8 Z M18.5,8 C19.8807119,8 21,9.11928813 21,10.5 C21,11.8807119 19.8807119,13 18.5,13 C17.1192881,13 16,11.8807119 16,10.5 C16,9.11928813 17.1192881,8 18.5,8 Z M5.5,10 C5.22385763,10 5,10.2238576 5,10.5 C5,10.7761424 5.22385763,11 5.5,11 C5.77614237,11 6,10.7761424 6,10.5 C6,10.2238576 5.77614237,10 5.5,10 Z M18.5,10 C18.2238576,10 18,10.2238576 18,10.5 C18,10.7761424 18.2238576,11 18.5,11 C18.7761424,11 19,10.7761424 19,10.5 C19,10.2238576 18.7761424,10 18.5,10 Z M12,2 C14.209139,2 16,3.790861 16,6 C16,8.209139 14.209139,10 12,10 C9.790861,10 8,8.209139 8,6 C8,3.790861 9.790861,2 12,2 Z M12,4 C10.8954305,4 10,4.8954305 10,6 C10,7.1045695 10.8954305,8 12,8 C13.1045695,8 14,7.1045695 14,6 C14,4.8954305 13.1045695,4 12,4 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStudents);
export default __webpack_public_path__ + "static/media/menu_students.1ab3285aac0a0d60a243a609d1edf978.svg";
export { ForwardRef as ReactComponent };